if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	//HOME ARROW
	$('.hero-arrow').click(function (event) {
		$('body, html').animate(
			{
				scrollTop: $(window).height() - $('header').outerHeight() * 2,
			},
			800,
		)
	})

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))

	$('.sym-slides').slick()

	if ($('#default.contact-us').length > 0) {
		$('.thankyouMsg, #frmContact').wrapAll("<div class='form-module-wrapper__container animate-fade top'></div>")
	}

	var urlPage = document.URL
	if (urlPage.indexOf('#') != -1) {
		urlPage = urlPage.split('#')[1]
		var top_ele = $('#' + urlPage).offset().top
		$('html,body')
			.animate({ scrollTop: top_ele - 150 }, 1500)
			.delay(1000)
	}

	const slickCards = () => {
		let slickElements = document.querySelectorAll("[data-tb-slick='cards']")

		slickElements.forEach((slickElement) => {
			if (slickElement.dataset.tbSlickElements === undefined) return
			let numberToShow = parseInt(slickElement.dataset.tbSlickElements)

			$(slickElement).slick({
				arrows: false,
				infinite: true,
				fade: false,
				slidesToShow: numberToShow,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1040,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 640,
						settings: {
							dots: true,
							slidesToShow: 1,
						},
					},
				],
			})
		})
	}

	slickCards()
	
	//accordion module

	const tabAccordionElement = [...document.getElementsByClassName('js-title-toggle')] || []
	const contentAccordionElement = [...document.getElementsByClassName('js-info-toggle')] || []

	tabAccordionElement.forEach(function (elementTab) {
		elementTab.addEventListener('click', function () {
			const clickedElement = this
			clickedElement.classList.toggle('change-icon')
			tabAccordionElement.forEach(function (elementClass) {
				if (elementClass !== clickedElement) elementClass.classList.remove('change-icon')
			})
			contentAccordionElement.forEach(function (elementContent) {
				let dataElementTab = elementTab.dataset.expand
				let dataElementContent = elementContent.dataset.expand

				elementContent.classList.add('info-toggle')



				if (elementTab.classList.contains('change-icon')) {
					if (dataElementTab === dataElementContent) {
						elementContent.classList.remove('info-toggle')
					}
				} else {
					if (dataElementTab === dataElementContent) {
						elementContent.classList.add('info-toggle')
					}
				}
			})
			let rect = this.getBoundingClientRect();
			// console.log(rect);
			// console.log(-rect.height);
			console.log(rect.top);
			// let y = rect.top;
			console.log(window.scrollY);
			rect = rect.top + window.pageYOffset;
			console.log(rect);
			// let clientHeight = document.querySelector(".info-toggle").clientHeight;
			

			  window.scrollTo(0, (rect - 400));
			//  console.log(clientHeight);

		})
	})
	
})()
